import { render, staticRenderFns } from "./ImgVue.vue?vue&type=template&id=fe05271c&scoped=true"
import script from "./ImgVue.vue?vue&type=script&lang=js"
export * from "./ImgVue.vue?vue&type=script&lang=js"
import style0 from "./ImgVue.vue?vue&type=style&index=0&id=fe05271c&prod&rel=stylesheet%2Fscss&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe05271c",
  null
  
)

export default component.exports